export const GETPAGE = 'GETPAGE'
export const GETPAGEPARENT = 'GETPAGEPARENT'
export const ADDPAGE = 'ADDPAGE'
export const EDITPAGE = 'EDITPAGE'
export const DELETEPAGE = 'DELETEPAGE'



// WEBPACK FOOTER //
// ./src/store/dataDictionary/types.js